module.exports = __webpack_public_path__ + "img/header-diamondJewelry050Carat@2x.f9b6aba.webp";